import { Component } from '@angular/core';
import { App } from 'ionic-angular';

/**
 * Forgot Page
 * 
 * @export
 * @class AccountNamePage
 */
@Component({
  selector: 'account-name',
  templateUrl: 'account-name.html'
})
export class AccountNamePage {
  constructor(
    public app: App
  ) {}
  ionViewDidEnter() {
    this.app.setTitle('Change Account Name');
  }
}


// WEBPACK FOOTER //
// ./src/pages/account-name/account-name.ts